/**
 * Project - fasthelp5.fa2chat-product
 *
 * @desc Window関連ユーティリティ
 *
 * @author genka
 * @copyright Copyright 2018 TechMatrix Corporation, Inc. All rights reserved.
 */
import Vue from 'vue'
const Dom = require('element-ui/lib/utils/dom')

export default new class {
  static addEventListener = window.addEventListener || window.attachEvent
  static removeEventListener = window.removeEventListener || window.detachEvent

  /**
   * チャット画面を別ウィンドウで開いているか
   * @return {Boolean}
   */
  isSeparateWindow() {
    return window.parent === window
  }

  /**
   * チャット画面の表示モード（mobile or pc）を取得します。
   * @return {String} mobile or pc
   */
  getScreenMode() {
    const ua = window.navigator.userAgent.toLowerCase()
    if ((ua.indexOf('iphone') !== -1 || ua.indexOf('ipod') !== -1) ||
      (ua.indexOf('ipad') !== -1) ||
      (ua.indexOf('android') !== -1) ||
      (ua.indexOf('windows') !== -1 && ua.indexOf('phone') !== -1)) {
      return 'mobile'
    }
    return 'pc'
  }

  /**
   * チャット画面の表示モードがmobileか
   * @return {Boolean}
   */
  isMobileScreenMode() {
    return this.getScreenMode() === 'mobile'
  }

  /**
   * チャット画面の表示モードがpcか
   * @return {Boolean}
   */
  isPcScreenMode() {
    return this.getScreenMode() === 'pc'
  }

  /**
   * 画面モードを更新します。
   * @param  {String} screenMode
   */
  updateScreenMode(screenMode) {
    if (screenMode === 'pc') {
      Dom.removeClass(document.body, 'fc-screen-mode-mobile')
    } else if (screenMode === 'mobile') {
      Dom.addClass(document.body, 'fc-screen-mode-mobile')
    }
  }

  /**
   * 親Windowからのメッセージ受信イベントリスナーを追加します。
   * @param {string} messageType
   * @param {Function} listener
   * @param {boolean} once
   */
  addMessageEventListener(messageType, listener, once) {
    addEventListener('message', function (event) {
      if (event.data.type === messageType) {
        listener(event)
        if (once) {
          removeEventListener('message', listener)
        }
      }
    })
  }

  /**
   * 親Windowにメッセージ送信します。
   * @param  {Object}   data 送信データ
   */
  postMessageToParent(data) {
    window.parent.postMessage(data, Vue.prototype.$config.parentOrigin)
  }

  /**
   * 親Windowにドラッグ開始メッセージを送信します。
   * @param  {Event}   mousedownevent マウスダウンイベント
   */
  postDragStartMessageToParent(mousedownevent) {
    this.postMessageToParent({
      type: 'dragStart',
      position: {
        x: mousedownevent.pageX,
        y: mousedownevent.pageY
      }
    })
  }

  /**
   * 親Windowにフレーム初期化メッセージを送信します。
   * @param  {Object}   data フレーム設定情報
   */
  postInitFastchatFrameMessageToParent(fastchatFrameConfig) {
    this.postMessageToParent({
      type: 'initFastchatFrame',
      fastchatFrameConfig: fastchatFrameConfig
    })
  }

  /**
   * 親Windowにチャット画面表示メッセージを送信します。
   */
  postShowChatWindowMessageToParent() {
    this.postMessageToParent({
      type: 'showChatWindow'
    })
  }

  /**
   * 親Windowにチャット開始画面表示メッセージを送信します。
   */
  postShowChatStarterMessageToParent() {
    this.postMessageToParent({
      type: 'showChatStarter'
    })
  }

  /**
   * 親Windowに通知ラベルメッセージを送信します。
   */
  postNoticeLabelMessageToParent(label) {
    this.postMessageToParent({
      type: 'noticeLabel',
      label: label
    })
  }

  /**
   * 親Windowにチャット画面別ウィンドウオープンメッセージを送信します。
   */
  postOpenSeparateChatWindowMessageToParent() {
    this.postMessageToParent({
      type: 'openSeparateChatWindow'
    })
  }

  /**
   * 利用Webフォーム設定番号のWebフォーム画面を開く
   * @param {String} callSpecificKey 対象コール特定キー
   */
  openWebFormWindow(callSpecificKey) {
    const webFormUrl = Vue.prototype.$t('{webFormParentPath}/form{webFormSettingId}.html?specificKey={callSpecificKey}', {
      webFormParentPath: Vue.prototype.$config.webFormParentPath,
      webFormSettingId: Vue.prototype.$config.webFormSettingId,
      callSpecificKey: callSpecificKey
    })
    window.open(webFormUrl, '_blank')
  }

  /**
   * 別ウィンドウを開く
   * @param {String} url URL
   */
  openWindow(url) {
    window.open(url, '_blank')
  }

  /**
   * GETパラメータのオブジェクトを取得します。
   * @return {[Object]}
   */
  getQueryParamObject() {
    let queryString = window.location.search
    const queryObject = {}
    if (queryString) {
      queryString = queryString.substring(1)
      let parameters = queryString.split('&')
      for (let i = 0; i < parameters.length; i++) {
        let param = parameters[i].split('=')
        let paramName = decodeURIComponent(param[0])
        let paramValue = decodeURIComponent(param[1])
        queryObject[paramName] = paramValue
      }
    }
    return queryObject
  }
}()



// WEBPACK FOOTER //
// ./src/utils/WindowUtil.js